import React, { useEffect, useRef, useState } from 'react'
import FailAlert from '../../../../../components/Alerts/FailAlert';
import { ALL_ANIMATED_PRODUCTS, CreateAnimatedProducts, useAllClassFirstLevel } from '../../../../../graphql';
import useStore from '../../../../../store/useStore';
import LoadingWidget from '../../../../../components/LoadingWidget/LoadingWidget';
import { useMutation } from '@apollo/client';
import { MdClose } from 'react-icons/md'
import { t } from 'i18next';

interface Props {
  setAddProductsPopup: React.Dispatch<React.SetStateAction<boolean>>,
  setSuccessMsg: React.Dispatch<React.SetStateAction<string>>,
  setSuccess: React.Dispatch<React.SetStateAction<boolean>>,
}

const AddProducts = ({ setAddProductsPopup, setSuccess, setSuccessMsg }: Props) => {
  const storeData = useStore((state: any) => state.userData.store);

  const [fail, setFail] = useState(false);
  const [failMsg, setFailMsg] = useState("");

  const [selectedLink, setSelectedLink] = useState("categories");
  const [selectedOption, setSelectedOption] = useState<any>("");

  const [linkDrop, setLinkDrop] = useState(false);
  const [optionDrop, setOptionDrop] = useState(false);

  // Create
  const [createAnimatedProducts, { error, loading: CreateLoading }] = useMutation(CreateAnimatedProducts);

  // Drops ref's
  const linkRef = useRef<any>();
  const OptionRef = useRef<any>();

  useEffect(() => {
    document.body.addEventListener("click", (e) => {
      if (linkRef.current || OptionRef.current) {
        if (linkRef.current.contains(e.target as Node) || OptionRef.current.contains(e.target as Node)) {
          return
        }

        // else close the dropdown
        setLinkDrop(false);
        setOptionDrop(false);
      }
    })
  }, [])

  // i had to use a main state for control loading because of ui issues
  const [initialLoading, setInitialLoading] = useState(true);

  const [classFirstLevelData, { loading: CategoriesLoading, data: dataClassFirstLevelData }] = useAllClassFirstLevel();

  useEffect(() => {
    setInitialLoading(true);

    if (storeData) {
      (async () => {
        await classFirstLevelData({
          variables: { idStore: storeData.id }
        })

        setInitialLoading(false)
      })()
    }

  }, [storeData]);

  const submit = async (e: any) => {

    e.preventDefault();

    if (selectedLink === "categories") {
      if (selectedOption === "") {
        setFailMsg(t('haveToSelectCategory'))
        setFail(true)
        return
      }
    }

    await createAnimatedProducts({
      variables: {
        content: {
          idStore: storeData.id,
          rank: 3,
          link: selectedOption !== "" ? selectedOption.id : "",
          type: selectedLink
        }
      },
      refetchQueries: [{ query: ALL_ANIMATED_PRODUCTS, variables: { idStore: storeData.id } }]
    })


    if (!error) {
      setSuccessMsg(t('productsAddedSuccess'));
      setSuccess(true);
      setAddProductsPopup(false)
    }

  }

  return (
    <div className='fixed inset-0 z-50 flex items-center justify-center w-full min-h-screen py-6 bg-gray-900/10 backdrop-blur-md'>
      {fail && <FailAlert fail={fail} setFail={setFail} failMsg={failMsg} />}

      <div className='w-5/6 p-2 bg-white border sm:w-4/6 md:w-3/6 rounded-md'>
        {
          CreateLoading &&
          <div className='absolute top-0 left-0 z-30 flex items-center justify-center w-full h-full py-10 bg-white/70'>
            <svg aria-hidden="true" className="w-8 h-8 mr-2 text-gray-200 animate-spin fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
              <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
            </svg>
          </div>
        }

        <div className='flex justify-end py-2 text-gray-600'>
          <div onClick={() => setAddProductsPopup(false)} className='cursor-pointer'>
            <MdClose size={20} />
          </div>
        </div>

        <div>
          <div className='my-3'>
            <div className="relative mb-2" ref={linkRef}>

              <button onClick={(e) => { e.preventDefault(); setLinkDrop(!linkDrop) }} className="z-10 flex items-center justify-between w-full p-2 text-left text-gray-700 border border-gray-300 rounded-md bg-gray-50 focus:border-primary focus:outline-none">
                <span>
                  {t(selectedLink)}
                </span>

                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M16.939 10.939 12 15.879l-4.939-4.94-2.122 2.122L12 20.121l7.061-7.06z"></path>
                  <path d="M16.939 3.939 12 8.879l-4.939-4.94-2.122 2.122L12 13.121l7.061-7.06z"></path>
                </svg>
              </button>
              {linkDrop &&
                <div className="absolute right-0 z-20 w-full py-2 mt-2 origin-top-right bg-white border border-gray-300 rounded-md shadow-xl">
                  <div>
                    <div onClick={() => { setLinkDrop(false); setSelectedOption(""); setSelectedLink("categories") }} className="flex items-center p-3 text-sm text-gray-600 capitalize transition-colors duration-300 transform cursor-pointer hover:bg-gray-100">
                      <span className="mx-1">
                        {t('categoriesLink')}
                      </span>
                    </div>

                    <div onClick={() => { setLinkDrop(false); setSelectedOption(""); setSelectedLink("Best Selling") }}>
                      <div className="flex items-center p-3 text-sm text-gray-600 capitalize transition-colors duration-300 transform cursor-pointer hover:bg-gray-100">
                        <span className="mx-1">
                          {t('bestSelling')}
                        </span>
                      </div>
                    </div>

                    <div onClick={() => { setLinkDrop(false); setSelectedOption(""); setSelectedLink("Newest Products") }}>
                      <div className="flex items-center p-3 text-sm text-gray-600 capitalize transition-colors duration-300 transform cursor-pointer hover:bg-gray-100">
                        <span className="mx-1">
                          {t('newestProducts')}
                        </span>
                      </div>
                    </div>

                    <div onClick={() => { setLinkDrop(false); setSelectedOption(""); setSelectedLink("Discounts Products") }}>
                      <div className="flex items-center p-3 text-sm text-gray-600 capitalize transition-colors duration-300 transform cursor-pointer hover:bg-gray-100">
                        <span className="mx-1">
                          {t('discountsProducts')}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>

          <div ref={OptionRef}>
            {selectedLink === "categories" &&
              <>
                <div className="relative mb-4">
                  <button onClick={(e) => { e.preventDefault(); setOptionDrop(!optionDrop) }} className="z-10 flex items-center justify-between w-full p-2 text-left text-gray-700 border border-gray-300 rounded-md bg-gray-50 focus:border-primary focus:outline-none">
                    <span>
                      {selectedOption !== "" ? selectedOption.name : t('select')}
                    </span>

                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M16.939 10.939 12 15.879l-4.939-4.94-2.122 2.122L12 20.121l7.061-7.06z"></path>
                      <path d="M16.939 3.939 12 8.879l-4.939-4.94-2.122 2.122L12 13.121l7.061-7.06z"></path>
                    </svg>
                  </button>

                  {optionDrop &&
                    <div className="absolute right-0 z-20 w-full py-2 mt-2 origin-top-right bg-white border border-gray-300 rounded-md shadow-xl">
                      <div className="relative flex items-center w-full h-12 overflow-hidden bg-white border">
                        <div className="grid w-12 h-full text-gray-300 place-items-center">
                          <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                          </svg>
                        </div>

                        <input className="w-full h-full pr-2 text-sm text-gray-700 outline-none" type="text" id="search" placeholder={t('searchSomething')} />
                      </div>

                      {selectedLink === 'categories' &&
                        initialLoading ?
                        <LoadingWidget />
                        :
                        CategoriesLoading ?
                          <LoadingWidget />
                          :
                          dataClassFirstLevelData?.allClassFirstLevels.length === 0 ?
                            <div className='flex w-full p-2 mt-2 text-red-600 bg-red-200'>
                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M11.953 2C6.465 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.493 2 11.953 2zM12 20c-4.411 0-8-3.589-8-8s3.567-8 7.953-8C16.391 4 20 7.589 20 12s-3.589 8-8 8z"></path>
                                <path d="M11 7h2v7h-2zm0 8h2v2h-2z"></path>
                              </svg>
                              <span className='px-2'>{t('noCategories')}</span>
                            </div>
                            :
                            dataClassFirstLevelData?.allClassFirstLevels.map((category: any) => (
                              <div key={category.id} onClick={() => { setSelectedOption(category); setOptionDrop(false) }}>
                                <div className="flex items-center p-3 text-sm text-gray-600 capitalize transition-colors duration-300 transform cursor-pointer hover:bg-gray-100">
                                  <span className="mx-1">
                                    {category.name}
                                  </span>
                                </div>
                              </div>
                            ))
                      }
                    </div>
                  }
                </div>
              </>
            }
          </div>
        </div>

        <div className='flex justify-end my-2'>
          <div onClick={(e) => { submit(e) }} >
            <button className='inline-flex items-center justify-center px-4 py-2 my-2 overflow-hidden text-sm text-white transition-colors duration-300 rounded-lg shadow bg-primary sm:w-auto md:my-0 hover:bg-primaryHover'>
              <span className="mx-2">
                {t('save')}
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AddProducts